<form [formGroup]="dayForm">
    <div class="row topAndmargin">
        <div class="col">
            <app-time-select [label]="'pages.branches.timeSlotDialog.input.from'" formControlName="from"
                (timeChange)="onTimeChange()" [disabled]="disabled"
                [requiredErrorKey]="'pages.branches.timeSlotDialog.inputValidation.from.required'"
                [invalidErrorKey]="'pages.branches.timeSlotDialog.inputValidation.from.invalid'">
            </app-time-select>
        </div>
        <div class="col">
            <app-time-select [label]="'pages.branches.timeSlotDialog.input.to'" formControlName="to"
                (timeChange)="onTimeChange()" [disabled]="disabled"
                [requiredErrorKey]="'pages.branches.timeSlotDialog.inputValidation.to.required'"
                [invalidErrorKey]="'pages.branches.timeSlotDialog.inputValidation.to.invalid'">
            </app-time-select>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col">
            <label>{{'pages.branches.deliveryTypeDialog.input.ondemandcutoff' | translate}}</label>
            <input type="number" min="1" max="4320" formControlName="cutOff" class="form-control"
                (input)="onValueChange()" [attr.disabled]="(!fromControl?.value || !toControl?.value) ? '' : null">
            <div *ngIf="cutOffControl?.errors" class="feedback">
                <div *ngIf="cutOffControl?.errors?.['required']">
                    {{'pages.branches.timeSlotDialog.inputValidation.from.required' | translate}}
                </div>
                <div *ngIf="cutOffControl?.errors?.['min']">
                    {{'pages.branches.timeSlotDialog.inputValidation.from.min' | translate:
                    cutOffControl?.errors?.['min'] }}
                </div>
                <div *ngIf="cutOffControl?.errors?.['max']">
                    {{'pages.branches.timeSlotDialog.inputValidation.from.max' | translate:
                    cutOffControl?.errors?.['max'] }}
                </div>
            </div>
        </div>
        <div class="col">
            <app-slot-interval-select formControlName="slotInterval"
                [disabled]="(!fromControl?.value || !toControl?.value)" (intervalChange)="onValueChange()">
            </app-slot-interval-select>
        </div>
    </div>
    <div class="row">
        <i>{{'pages.branches.timeSlotDialog.hint' | translate}}</i>
    </div>
</form>